import {SearchItem} from "./search/search-table.dto.res";
import {DocumentContactDto} from "./document-contact.dto";
import {SubInvoiceDto} from "./sub-invoice.dto";

export class ProformaInvoiceDto implements SubInvoiceDto, SearchItem {

  public readonly id!: string;
  public readonly number!: string;
  public readonly mediaId!: string;
  public readonly filename!: string;
  public readonly created!: Date;

  // Transient: is set for price calc for a letter (in media-viewer)
  public contact: DocumentContactDto | undefined;

  constructor(init?: Partial<ProformaInvoiceDto> | undefined) {
    Object.assign(this, init);
    if (init?.created) {
      this.created = new Date(init.created);
    }
  }

  isDeliveryNote(): boolean {
    return false;
  }

  isProformaInvoice(): boolean {
    return true;
  }

  isEditable(): boolean {
    return false;
  }

  public clone(): SubInvoiceDto {
    return new ProformaInvoiceDto(this);
  }
}
